import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2196F3", // Change this to your desired primary color
    },
    secondary: {
      main: "#FFC107", // Change this to your desired secondary color
    },
  },
});

export default theme;
